// client/src/App.js
import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import CustomNavbar from './components/Navbar';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import ServicesPage from './pages/ServicesPage';
import BlogPage from './pages/BlogPage';
import ContactPage from './pages/ContactPage';
import ResourcesPage from './pages/ResourcesPage';
import Footer from './components/Footer';
import NewsPage from './pages/NewsPage';
import ScrollToTop from './components/ScrollToTop';
import './styles.css'; // Import global styles
import './styles/App.css'; // Import App styles

function App() {
    return (
        <Router>
            <div className="App">
                <ScrollToTop />
                <CustomNavbar />
                <div className="content">
                    <Routes>
                        <Route path="/" element={<HomePage />} />
                        <Route path="/about" element={<AboutPage />} />
                        <Route path="/services" element={<ServicesPage />} />
                        <Route path="/blog" element={<BlogPage />} />
                        <Route path="/contact" element={<ContactPage />} />
                        <Route path="/resources" element={<ResourcesPage />} />
                        <Route path="/news/:index" element={<NewsPage />} />
                        {/* Add a catch-all route */}
                        <Route path="*" element={<HomePage />} />
                    </Routes>
                </div>
                <Footer />
            </div>
        </Router>
    );
}

export default App;
